import { ActionResponse, ErrorResponseHelper, FeedBackType, MessageHelper, ResponseHook, UIFeedbackHooks } from "@/Shared"
import { useState } from "react";
import { MediaService } from "./MediaService";

export const useDeleteMedia = (
    uiFeedbackHooks: UIFeedbackHooks = {} as UIFeedbackHooks,
     onClose : () => void
) => {

    const { toastHook, confirmHook } = uiFeedbackHooks;
    /**
     * ActionResponse state used to track the export request status
     * (idle, loading, success, error).
     */
    const [deleteResponse, setDeleteResponse] = useState<ActionResponse>({ status: 'idle' });


    const deletePropertyMedia = async (mediaId: number) => {

        const confirmed = await confirmHook.openConfirm?.({
            title: MessageHelper.MODAL.CONFIRM.TITLE,
            content: MessageHelper.MODAL.CONFIRM.DELETING('Media'),
        });

        if (confirmed) {
            ResponseHook.loading(setDeleteResponse);
            toastHook.openToast({
                data: {
                    message: MessageHelper.DELETING.LOADING('Media'),
                    type: FeedBackType.INFO
                }
            });

            MediaService.deletePropertyMedia(mediaId).then(data => {

                ResponseHook.success(setDeleteResponse);
                toastHook.openToast({
                    data: {
                        message: MessageHelper.DELETING.SUCCESS('Media'),
                        type: FeedBackType.SUCCESS
                    },
                    onClose
                });

            }).catch(error => {
                ResponseHook.error(setDeleteResponse, error, MessageHelper.DELETING.ERROR('Media'));
                toastHook.openToast({
                    data: {
                        message: ErrorResponseHelper.getError(error, MessageHelper.DELETING.ERROR('Media')).error,
                        type: FeedBackType.ERROR
                    }
                });
            });
        }
    }

    return {
        deletePropertyMedia,
        deleteResponse
    }
}